import { FC } from "react";

import { RideNearbyNoSearch, RidesNearbyFunnel } from "@ryde/controls";
import { FETCH_RIDE_NEARBY_EXCLUDED_STATUSES, IRideDto } from "@ryde/shared";

interface IKanbanItemFilterPopoverProps {
  rideDto: IRideDto;
}

export const KanbanItemFilterPopover: FC<IKanbanItemFilterPopoverProps> = ({
  rideDto,
}) => {
  const { id, status } = rideDto;
  const shouldFetchNearby =
    !FETCH_RIDE_NEARBY_EXCLUDED_STATUSES.includes(status);

  return (
    <>
      {!shouldFetchNearby && <RideNearbyNoSearch />}
      {shouldFetchNearby && <RidesNearbyFunnel rideId={id} />}
    </>
  );
};
